<template>
  <div style="height: 100%">
    <div class="header d-flex justify-space-between">
      <p class="mb-0">Chat</p>
      <div class="d-flex">
        <!-- <v-btn small class="new-chat-btn" max-height="23" height="23" depressed>
          <v-icon size="18" class="mr-2">{{ mdiPlus }}</v-icon>
          <span>new Chat</span>
        </v-btn> -->
        <v-icon class="cancel-icon" size="21" style="cursor: pointer" @click="$emit('close')">{{
          mdiClose
        }}</v-icon>
      </div>
    </div>
    <div class="message">
      <div class="body" ref="chatContainer">
        <div v-for="(item, index) in chatMessages" :key="index">
          <div v-if="item.type === 'ai'" class="aiMessage">
            <div class="logo">
              <v-img
                :src="require('@/assets/images/png/helmat.png')"
                height="22"
                width="22"
              ></v-img>
            </div>
            <div v-if="item.loading" class="msg">{{ 'typing...' }}</div>
            <div v-else style="max-width: 85%">
              <pre
                v-if="item.code"
                class="msg pre-bldon-code"
                @click="goToRoute(item.message)"
                :class="{ 'linked-msg': item.isLinked }"
              ><code>{{ formatMessage(item.message) }}</code></pre>
              <div v-else class="msg">{{ item.message }}</div>
            </div>
          </div>
          <div v-if="item.type === 'user'" class="userMessage">
            <div class="msg">
              <div style="white-space: pre-wrap">{{ item.message }}</div>
            </div>
            <div class="logo">
              <v-avatar
                color="primary"
                style="background: #ddd"
                size="26"
                rounded
                class="avatar-text"
              >
                <span>{{ avatarText(`${userData.firstname} ${userData.lastname}`) }}</span>
              </v-avatar>
            </div>
          </div>
        </div>
      </div>
      <div class="footer">
        <div class="bldon-input">
          <v-textarea
            v-model="inputMessage"
            placeholder="Message BldonAI..."
            auto-grow
            solo
            class="ai-textarea no-border"
            hide-details
            rows="1"
            row-height="10"
            @keydown="handleKeydown"
          />
          <div
            class="text-right"
            style="text-align: right; padding-right: 5px; padding-bottom: 5px"
          >
            <v-icon size="19" @click="sendMessage" :disabled="loading" style="color: #fe724c">{{
              mdiSend
            }}</v-icon>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { mdiClose, mdiPlus, mdiSend } from '@mdi/js'
import { ref, onMounted, computed } from '@vue/composition-api'
import { storeActions, storeGetters } from '@/store/storeConstants'
import { avatarText } from '@core/utils/filter'

import store from '@/store'
import { useRouter } from '@core/utils'

export default {
  setup() {
    const userData = computed(() => store.getters[`auth/${storeGetters.GET_USER_INFO}`])

    const inputMessage = ref('')
    const sessionId = ref('')
    const chatContainer = ref(null)
    const chatMessages = ref([
      {
        type: 'ai',
        message: 'Welcome to BLDON AI Assistance.',
        code: false,
        loading: false,
        isLinked: false,
      },
    ])
    const loading = ref(false)
    const { router } = useRouter()

    const handleKeydown = event => {
      if (event.key === 'Enter' && event.shiftKey) {
        event.preventDefault()
        inputMessage.value += '\n'
      } else if (event.key === 'Enter') {
        event.preventDefault()
        sendMessage()
      }
    }

    const formattedJson = data => {
      return JSON.stringify(data, null, 2) // Format with indentation
    }

    const getOrdinal = n => {
      const s = ['th', 'st', 'nd', 'rd'],
        v = n % 100
      return s[(v - 20) % 10] || s[v] || s[0]
    }

    const formatDate = dateStr => {
      const date = new Date(dateStr)
      const day = date.getDate()
      const monthName = date.toLocaleString('default', { month: 'long' })
      const year = date.getFullYear()
      return `${day}${getOrdinal(day)} ${monthName} ${year}`
    }

    const sendMessage = () => {
      if (!inputMessage.value) return
      loading.value = true
      chatMessages.value.push({
        type: 'user',
        message: inputMessage.value,
        code: false,
        loading: false,
        isLinked: false,
      })

      chatMessages.value.push({
        type: 'ai',
        message: '',
        code: false,
        loading: true,
        isLinked: false,
      })

      setTimeout(() => {
        scrollToBottom()
      }, 10)

      const payload = {
        object: {
          user_input: inputMessage.value,
          ...(sessionId.value ? { session_id: sessionId.value } : {}),
        },
        component: 'setup/ai-chat/send-message',
      }

      inputMessage.value = ''
      store
        .dispatch(`common/${storeActions.CREATE}`, payload)
        .then(({ data }) => {
          if (data.success) {
            chatMessages.value.pop()
            sessionId.value = data.data.session_id
            // this logic added for redirecting user to the module (because prevously we are maintaining data in objects, but now data format change to Array)
            // let modulePushed = false
            const responseData = data.data.data

            if (Array.isArray(responseData)) {
              if (responseData.length === 0) {
                chatMessages.value.push({
                  type: 'ai',
                  message: 'No data found.',
                  loading: false,
                  code: false,
                  isLinked: false,
                })
              } else {
                let modulePushed = false
                const formattedDates = []
                const nameItems = []

                responseData.forEach(item => {
                  const isLinked = !!item.uuid

                  if (isLinked) {
                    if (!modulePushed) {
                      chatMessages.value.push({
                        type: 'ai',
                        message: data.data.module,
                        loading: false,
                        code: data.data.type === 'query',
                        isLinked: true,
                      })
                      modulePushed = true
                    }
                  } else if (item.name) {
                    nameItems.push(item.name)
                  } else if (item.date) {
                    formattedDates.push(formatDate(item.date))
                  } else {
                    chatMessages.value.push({
                      type: 'ai',
                      message: item,
                      loading: false,
                      code: data.data.type === 'query',
                      isLinked: false,
                    })
                  }
                })

                if (nameItems.length > 0) {
                  chatMessages.value.push({
                    type: 'ai',
                    message: nameItems.join('\n'),
                    loading: false,
                    code: data.data.type === 'query',
                    isLinked: false,
                  })
                }
                if (formattedDates.length > 0) {
                  chatMessages.value.push({
                    type: 'ai',
                    message: formattedDates.join('\n'),
                    loading: false,
                    code: data.data.type === 'query',
                    isLinked: false,
                  })
                }
              }
            } else if (typeof responseData === 'string') {
              chatMessages.value.push({
                type: 'ai',
                message: responseData,
                loading: false,
                code: data.data.type === 'query',
                isLinked: false,
              })
            }
          } else {
            chatMessages.value.pop()
            chatMessages.value.push({
              type: 'ai',
              message:
                'The requested resource could not be found. Please try searching with a different input',
              code: false,
              loading: false,
              isLinked: false,
            })
          }
        })
        .catch(() => {
          chatMessages.value.pop()
          chatMessages.value.push({
            type: 'ai',
            message:
              'The requested resource could not be found. Please try searching with a different input',
            code: false,
            loading: false,
            isLinked: false,
          })
        })
        .finally(() => {
          loading.value = false

          scrollToBottom()
        })
    }

    const scrollToBottom = () => {
      if (chatContainer.value) {
        chatContainer.value.scrollTop = chatContainer.value.scrollHeight
      }
    }

    const goToRoute = message => {
      if (message.toLowerCase() == 'estimations') {
        router.push({
          name: 'estimation-dashboard',
        })
      } else if (message.toLowerCase() == 'vendors') {
        router.push({
          name: 'vendors',
        })
      } else if (message.toLowerCase() == 'materials') {
        router.push({
          name: 'material-management',
        })
      } else if (message.toLowerCase() == 'task') {
        router.push({
          name: 'task-dashboard',
        })
      } else if (
        message.toLowerCase() == 'inventory' ||
        message.toLowerCase() == 'inventories' ||
        message.toLowerCase() == 'warehouses'
      ) {
        router.push({
          path: '/inventory-management/warehouse',
        })
      } else if (message.toLowerCase() == 'accounts') {
        router.push({
          name: 'crm-account',
        })
      } else if (
        message.toLowerCase() == 'projects' ||
        message.toLowerCase() == 'projectmanagemant'
      ) {
        router.push({
          name: 'pm-dashboard',
        })
      } else if (message.toLowerCase() == 'manufacturing') {
        router.push({
          name: 'goals-dashboard',
        })
      } else if (message.toLowerCase() == 'crm') {
        router.push({
          name: 'dashboard-crm',
        })
      } else if (message.toLowerCase() == 'opportunities') {
        router.push({
          name: 'crm-opportunity',
        })
      } else if (message.toLowerCase() == 'leads') {
        router.push({
          name: 'crm-lead',
        })
      } else if (message.toLowerCase() == 'contacts') {
        router.push({
          name: 'crm-contact',
        })
      }
    }

    const formatMessage = message => {
      try {
        if (typeof message === 'string') {
          message = JSON.parse(message)
        }
        if (typeof message === 'object' && message !== null) {
          return Object.entries(message)
            .map(([key, value]) => `${key}: ${value}`)
            .join('\n')
        }
        return message
      } catch (error) {
        return message
      }
    }

    onMounted(() => {
      scrollToBottom()
    })

    return {
      formatMessage,
      inputMessage,
      handleKeydown,
      loading,
      userData,
      avatarText,
      chatContainer,
      chatMessages,
      sendMessage,
      sessionId,
      mdiPlus,
      mdiSend,
      mdiClose,
      goToRoute,
    }
  },
}
</script>
<style scoped lang="scss">
.new-chat-btn {
  background: white !important;
  color: #fe724c;
  box-shadow: 0px 2px 1px 0px #ffffff38 inset !important;
  box-shadow: 0px -2px 0.3px 0px #0e387d2e inset !important;
  margin-right: 10px;
  padding: 0 10px;
}

.bldon-input {
  border: 1px solid #cbd5e1;
  border-radius: 10px;
  overflow: hidden;
  display: flex;
  align-items: center;
}
::v-deep {
  .ai-textarea.v-text-field.v-text-field--solo:not(.v-text-field--solo-flat)
    > .v-input__control
    > .v-input__slot {
    box-shadow: none;
  }
}

.message {
  display: flex;
  flex-direction: column;
  height: 91%;
  .body {
    flex-grow: 1;
    margin: 10px 0px 2px 10px;
    overflow: auto;
  }

  .footer {
    margin: 1px 10px 10px 10px;
  }
}
.header {
  height: 50px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 0 10px;
  background: #072146;
  color: white;
}
.cancel-icon {
  color: #fff;
}

.aiMessage {
  width: 90%;
  display: flex;
  padding: 5px;
  align-items: flex-start;
  justify-content: flex-start;
  padding-bottom: 10px;

  .logo {
    margin-right: 8px;
  }

  .msg {
    border: 1px solid #ced5de;
    min-height: 30px;
    display: flex;
    font-size: 14px;
    color: #1e293b;
    align-items: center;
    padding: 10px;
    border-radius: 14px;
    max-width: 100%;
  }
}

.userMessage {
  display: flex;
  padding: 5px;
  align-items: flex-start;
  justify-content: end;
  padding-bottom: 10px;
  padding-right: 10px;
  .logo {
    margin-left: 8px;
  }

  .msg {
    min-height: 30px;
    display: flex;
    font-size: 14px;
    color: #fff;
    background: #fe724c;
    align-items: center;
    padding: 10px;
    border-radius: 14px;
    text-align: left;
    max-width: 80%;
    flex-flow: column;
  }
}

.pre-bldon-code {
  background-color: #f5f5f5;
  padding: 10px;
  border-radius: 5px;
  overflow: auto;
  font-size: 0.8em;
  cursor: pointer;
}
.linked-msg {
  color: #185ac7 !important;
  text-decoration-line: underline;
}

.avatar-text {
  font-size: 13px;
  color: white;
  border-radius: 12px !important;
}
</style>
